import React from 'react';

type LinkItem = {
    text: string;
    onClick?: () => void;
    isLink?: boolean;
};

type CheckboxProps = {
    register: any;
    disabled?: boolean
    id?: string;
    name?: string;
    errorMessage?: React.ReactNode;
    labelText?: string;
    links: LinkItem[];
};

const CheckboxWithLabel: React.FC<CheckboxProps> = ({
    register,
    disabled = false,
    id = 'Checkbox',
    name = 'agree_tnc',
    labelText = '',
    links,
    errorMessage
}) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const uniqueId = React.useId();
    const inputId = id === 'Checkbox' ? `${uniqueId}-checkbox` : id;

    return (
        <div className="com-check auth-check">
            <div className="checkbox-row">
                <input
                    type="checkbox"
                    className="form-check-input custom-checkbox position-absolute"
                    style={{ display: 'block', opacity: 0, pointerEvents: 'none', width: '20px', height: '20px', zIndex: -1 }}
                    id={inputId}
                    disabled={disabled}
                    {...register(name)}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />

                <label className="form-check-label" htmlFor={inputId}>
                    <span 
                        className="check-icon" 
                        style={{
                            outline: isFocused ? '2px solid #5252F6' : 'none',
                            outlineOffset: '2px',
                            borderRadius: '4px'
                        }}
                    />
                    <span className="checkbox-text">
                        {labelText}{' '}
                        {links.map((item, index) => (
                            <span key={index}>
                                {item.isLink && item.onClick ? (
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation(); // prevent checkbox toggle
                                            item.onClick?.();
                                        }}
                                        className="text-decoration-underline cursor-pointer"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal"
                                    >
                                        {item.text}
                                    </a>
                                ) : (
                                    <span
                                        onClick={(e) => e.stopPropagation()} // prevent checkbox toggle
                                    >
                                        {item.text}
                                    </span>
                                )}
                                {index < links.length - 2 ? ' ' : ''}
                            </span>
                        ))}
                    </span>
                </label>
            </div>
            {errorMessage}
        </div>
    );
};

export default CheckboxWithLabel;